// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v1.users.properties.convert.RentalManagerUserPropertyConvertWebApiHandler

import type { UseMutationOptions } from '@zg-rentals/react-query5';
import { useMutation } from '@zg-rentals/react-query5';
import { tsClientOptions } from '@zg-rentals/react-query5';
import type { Client } from '@zg-rentals/http-client';
import {
  RentalManagerUserPropertyConvertWebApiHandler_multiToSingleFamily,
  RentalManagerUserPropertyConvertWebApiHandler_singleFamilyToRoomForRent,
} from '@zg-rentals/ts-rental-manager-api-client';

import type {
  ListingAlias,
  UserPropertyConvertMultiToSingleFamilyResponseWebDto,
  UserPropertyConvertSingleFamilyToRoomForRentResponseWebDto,
} from '@zg-rentals/ts-rental-manager-api-client';

interface MultiToSingleFamilyParams {
  modelId: string;
  unit?: string;
}
interface SingleFamilyToRoomForRentParams {
  listingAlias: ListingAlias;
}

export interface RentalManagerUserPropertyConvertWebApiHandler_multiToSingleFamily_Args {
  getParams: MultiToSingleFamilyParams;
}

export type RentalManagerUserPropertyConvertWebApiHandler_multiToSingleFamily_Options = UseMutationOptions<
  UserPropertyConvertMultiToSingleFamilyResponseWebDto,
  unknown,
  RentalManagerUserPropertyConvertWebApiHandler_multiToSingleFamily_Args
>;

/**
 * Convert a multifamily property to a single family property
 * @deprecated
 */
export const useRentalManagerUserPropertyConvertWebApiHandler_multiToSingleFamily = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyConvertWebApiHandler_multiToSingleFamily_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyConvertWebApiHandler_multiToSingleFamily_Args) =>
      RentalManagerUserPropertyConvertWebApiHandler_multiToSingleFamily(args.getParams, httpClient),
  });
};

export interface RentalManagerUserPropertyConvertWebApiHandler_singleFamilyToRoomForRent_Args {
  getParams: SingleFamilyToRoomForRentParams;
}

export type RentalManagerUserPropertyConvertWebApiHandler_singleFamilyToRoomForRent_Options = UseMutationOptions<
  UserPropertyConvertSingleFamilyToRoomForRentResponseWebDto,
  unknown,
  RentalManagerUserPropertyConvertWebApiHandler_singleFamilyToRoomForRent_Args
>;

/**
 * Convert a single family property to a room for rent property
 * @deprecated
 */
export const useRentalManagerUserPropertyConvertWebApiHandler_singleFamilyToRoomForRent = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyConvertWebApiHandler_singleFamilyToRoomForRent_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyConvertWebApiHandler_singleFamilyToRoomForRent_Args) =>
      RentalManagerUserPropertyConvertWebApiHandler_singleFamilyToRoomForRent(args.getParams, httpClient),
  });
};
